import React from "react";
import moment from "moment";
import { theme } from "../theme";

const CONTRACT_TYPE_LABELS = {
  CASH: "Cash",
  CREDIT: "Credit",
  DEVELOPER: "Developer",
  "PRE-CONTRACT": "Pre-Contract",
  OTHER: "Other",
};

const fieldLabel = { fontSize: 12.5, color: theme.textMuted };
const fieldValue = { fontSize: 14, fontWeight: 600, marginTop: 3, color: theme.text };

const ContractTermsCard = ({ contract }) => {
  return (
    <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 14 }}>
      <div style={{ padding: "16px 18px 14px", borderBottom: "1px solid #eeeef2" }}>
        <h2 style={{ margin: 0, fontSize: 15.5, fontWeight: 650, letterSpacing: "-0.2px" }}>Terms</h2>
      </div>
      <div
        style={{
          padding: 18,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "16px 24px",
        }}
      >
        <div>
          <div style={fieldLabel}>Contract type</div>
          <div style={fieldValue}>{CONTRACT_TYPE_LABELS[contract?.type] || contract?.type || "—"}</div>
        </div>
        <div>
          <div style={fieldLabel}>Currency</div>
          <div style={fieldValue}>{contract?.currency}</div>
        </div>
        <div>
          <div style={fieldLabel}>Signed</div>
          <div style={fieldValue}>
            {contract?.pvc_date ? moment(contract.pvc_date).format("D MMM YYYY") : "—"}
          </div>
        </div>
        <div style={{ gridColumn: "1 / -1" }}>
          <div style={fieldLabel}>Internal notes</div>
          {contract?.notes ? (
            <div style={{ fontSize: 14, marginTop: 4, color: theme.textSecondary }}>{contract.notes}</div>
          ) : (
            <div style={{ fontSize: 14, marginTop: 4, color: theme.borderHover, fontStyle: "italic" }}>
              No notes yet
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContractTermsCard;
